<template>
  <div class="form form--sidepanel">
    <h4 v-t="'user_permissions.article_screen_data'"></h4>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="article_id"
        :value="checked.includes('article_id')"
        :onChange="(value) => onInputChange('article_id', value)"
      />
      <label for="article_id" v-t="'user_permissions.article_screen_data_options.article_id'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="headline"
        :value="checked.includes('headline')"
        :onChange="(value) => onInputChange('headline', value)"
      />
      <label for="headline" v-t="'user_permissions.article_screen_data_options.headline'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="date_created"
        :value="checked.includes('date_created')"
        :onChange="(value) => onInputChange('date_created', value)"
      />
      <label for="date_created" v-t="'user_permissions.article_screen_data_options.date_created'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="date_published"
        :value="checked.includes('date_published')"
        :onChange="(value) => onInputChange('date_published', value)"
      />
      <label for="date_published" v-t="'user_permissions.article_screen_data_options.date_published'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="outlet"
        :value="checked.includes('outlet')"
        :onChange="(value) => onInputChange('outlet', value)"
      />
      <label for="outlet" v-t="'user_permissions.article_screen_data_options.outlet'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="language"
        :value="checked.includes('language')"
        :onChange="(value) => onInputChange('language', value)"
      />
      <label for="language" v-t="'user_permissions.article_screen_data_options.language'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="assigned_to"
        :value="checked.includes('assigned_to')"
        :onChange="(value) => onInputChange('assigned_to', value)"
      />
      <label for="assigned_to" v-t="'user_permissions.article_screen_data_options.assigned_to'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="assigned_by"
        :value="checked.includes('assigned_by')"
        :onChange="(value) => onInputChange('assigned_by', value)"
      />
      <label for="assigned_by" v-t="'user_permissions.article_screen_data_options.assigned_by'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="status"
        :value="checked.includes('status')"
        :onChange="(value) => onInputChange('status', value)"
      />
      <label for="status" v-t="'user_permissions.article_screen_data_options.status'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="due_date"
        :value="checked.includes('due_date')"
        :onChange="(value) => onInputChange('due_date', value)"
      />
      <label for="due_date" v-t="'user_permissions.article_screen_data_options.due_date'"></label>
    </div>

    <div class="form-group form-group--inline">
      <input-checkbox
        id="fav_score"
        :value="checked.includes('fav_score')"
        :onChange="(value) => onInputChange('fav_score', value)"
      />
      <label for="fav_score" v-t="'user_permissions.article_screen_data_options.fav_score'"></label>
    </div>
    <div class="form-group form-group--inline">
      <input-checkbox
        id="outlet_tier"
        :value="checked.includes('outlet_tier')"
        :onChange="(value) => onInputChange('outlet_tier', value)"
      />
      <label for="fav_score" v-t="'user_permissions.article_screen_data_options.outlet_tier'"></label>
    </div>
  </div>
</template>

<script>
import InputCheckbox from '../form-components/input-checkbox';

export default {
  props: {
    row: Object,
    onChange: Function
  },

  data: function() {
    const checked = this.row.article_screen_data == null ? [] : [...this.row.article_screen_data];
    return {
      checked
    }
  },

  methods: {
    onInputChange(key, value) {
      if (value == true) {
        this.checked.push(key);
      }
      else {
        this.checked = this.checked.filter(k => k != key);
      }

      this.onChange(this.row.user_id, 'article_screen_data', this.checked);
    }
  },

  components: {
    InputCheckbox
  }
}
</script>

<style lang="scss" scoped>
  h4 {
    margin-bottom: 20px;
  }
</style>